var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensegluten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_833_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.22 263.76L79.587 291.393L87.4293 299.234L126.471 260.193C147.281 269.56 172.213 261.818 183.868 241.632C163.638 229.952 138.111 235.764 124.796 254.374L124.211 253.79C133.407 239.994 134.601 221.621 125.75 206.292C105.54 217.961 97.8037 242.936 107.22 263.76ZM137.915 239.128C159.44 226.7 166.814 199.177 154.387 177.654C132.862 190.081 125.488 217.604 137.915 239.128ZM240.296 91.7458C218.771 104.174 211.397 131.696 223.824 153.222C245.349 140.795 252.724 113.272 240.296 91.7458ZM208.302 172.198C229.828 184.625 257.35 177.251 269.777 155.726C248.251 143.299 220.729 150.674 208.302 172.198ZM292.407 78.77C267.553 78.77 247.405 98.9174 247.405 123.772C272.259 123.772 292.407 103.624 292.407 78.77ZM298.415 127.088C276.89 114.661 249.368 122.036 236.941 143.559C258.466 155.987 285.988 148.613 298.415 127.088ZM305.869 284.241L223.249 201.624C230.476 197.8 236.749 191.962 241.138 184.359C229.014 177.36 214.985 176.642 202.824 181.199L200.157 178.531C217.78 164.988 223.073 140.153 211.658 120.38C194.421 130.332 186.257 149.966 190.072 168.446L188.855 167.229C188.262 160.999 186.353 154.793 183.02 149.018C180.403 150.53 177.996 152.262 175.808 154.182L134.784 113.157L93.7588 72.132L72.1287 93.7631L160.854 182.488C159.691 191.865 161.46 201.681 166.547 210.493C171.294 207.754 175.352 204.28 178.662 200.298L185.551 207.187C171.628 208.579 158.555 216.428 151.026 229.471C168.058 239.303 188.847 236.738 202.939 224.573L284.238 305.873L305.869 284.241ZM351.716 189.004C351.716 278.872 278.866 351.724 188.996 351.724C99.1285 351.724 26.2765 278.874 26.2765 189.004C26.2765 99.1367 99.1266 26.2847 188.996 26.2847C278.864 26.2847 351.716 99.1348 351.716 189.004ZM365.3 189.004C365.3 91.6315 286.368 12.7051 189.001 12.7051C91.628 12.7051 12.7016 91.6362 12.7016 189.004C12.7016 286.372 91.6327 365.303 189.001 365.303C286.369 365.303 365.3 286.372 365.3 189.004Z",
    className: "svgFill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_833_1562",
    x: -4,
    y: 0,
    width: 386,
    height: 386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_833_1562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_833_1562",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensegluten);
export default __webpack_public_path__ + "static/media/sensegluten.23a09dba.svg";
export { ForwardRef as ReactComponent };